/**
 * va-logo-garde-2026.js · Dire au client que son logo est trop lourd,
 * AVANT qu'il croie l'avoir envoyé.
 * ====================================================================
 *
 * CE QUE ÇA RÈGLE, et c'est un vrai trou. Un logo trop lourd échoue
 * AUJOURD'HUI EN SILENCE. Vérifié dans le module compilé qui dépose les
 * logos : il envoie avec `keepalive: true` et avale la réponse avec un
 * `.catch(function(){})`. Le relais refuse au-delà de 4 Mo et renvoie un
 * message clair — que personne ne lit jamais.
 *
 * Résultat pour le client : son logo s'affiche à l'écran (il est dans la
 * mémoire de son navigateur), il continue sa commande, et le fichier
 * n'atteint jamais la boutique. Personne ne le sait. Ni lui, ni le vendeur.
 *
 * POURQUOI 3 Mo ET PAS 4. Le logo voyage encodé en base64, ce qui l'alourdit
 * d'un tiers. Un fichier de 3 Mo arrive donc à ~4 Mo une fois encodé, et 4 Mo
 * est exactement le plafond du relais. Annoncer 4 Mo serait annoncer une
 * limite qui ne passe pas.
 *
 * POURQUOI ICI ET PAS DANS L'APPLICATION. Le champ de fichier est rendu par un
 * des 1510 modules compilés dont le code source est chez Fred. On n'y touche
 * pas. À la place, on écoute le document en phase de CAPTURE : l'événement y
 * passe avant d'atteindre le champ et avant React. On peut donc arrêter net un
 * fichier trop lourd sans rien savoir de qui l'affiche.
 *
 * ON NE BLOQUE JAMAIS PAR ERREUR. Tout est sous try/catch : si quoi que ce
 * soit échoue ici, l'événement suit son cours normal. Une garde qui plante ne
 * doit pas empêcher une vente.
 */
(function () {
  "use strict";

  var MAX = 3 * 1024 * 1024;                 // 3 Mo de fichier réel
  var LIBELLE = "3 Mo";

  function mo(n) {
    return (n / 1048576).toFixed(n < 10485760 ? 1 : 0).replace(".", ",");
  }

  /* ------------------------------------------------------------------ */
  /* Le message                                                          */
  /* ------------------------------------------------------------------ */

  var boite = null;
  var minuteur = null;

  function styler(el, regles) {
    for (var k in regles) el.style[k] = regles[k];
  }

  function dire(nom, octets) {
    try {
      if (!boite) {
        boite = document.createElement("div");
        boite.setAttribute("role", "alert");
        styler(boite, {
          position: "fixed", zIndex: "2147483000", left: "50%",
          transform: "translateX(-50%)", top: "16px", maxWidth: "min(560px, calc(100vw - 32px))",
          boxSizing: "border-box", padding: "14px 44px 14px 16px", borderRadius: "12px",
          background: "#1d1d1f", color: "#fff", boxShadow: "0 10px 30px rgba(0,0,0,.28)",
          font: "500 14px/1.45 -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
        });
        var x = document.createElement("button");
        x.type = "button";
        x.setAttribute("aria-label", "Fermer");
        x.textContent = "×";
        styler(x, {
          position: "absolute", top: "8px", right: "10px", border: "0", background: "transparent",
          color: "#fff", fontSize: "20px", lineHeight: "1", cursor: "pointer", padding: "4px",
        });
        x.addEventListener("click", function () { cacher(); });
        boite.appendChild(x);
        var p = document.createElement("div");
        p.setAttribute("data-va-texte", "1");
        boite.appendChild(p);
        document.body.appendChild(boite);
      }
      var cible = boite.querySelector("[data-va-texte]");
      cible.textContent = "";

      var l1 = document.createElement("div");
      l1.style.marginBottom = "4px";
      l1.textContent = "« " + (nom || "Ton fichier") + " » pèse " + mo(octets) +
                       " Mo. Le maximum est de " + LIBELLE + ".";
      var l2 = document.createElement("div");
      styler(l2, { opacity: ".85", fontWeight: "400" });
      l2.textContent = "Envoie une version plus légère. Un fichier vectoriel " +
                       "(.svg, .pdf, .ai, .eps) est à la fois beaucoup plus léger et " +
                       "meilleur à l'impression.";
      cible.appendChild(l1);
      cible.appendChild(l2);

      boite.style.display = "block";
      if (minuteur) clearTimeout(minuteur);
      minuteur = setTimeout(cacher, 15000);
    } catch (e) { /* un message qui ne s'affiche pas ne doit rien casser */ }
  }

  function cacher() {
    try { if (boite) boite.style.display = "none"; } catch (e) {}
  }

  /* ------------------------------------------------------------------ */
  /* La garde                                                            */
  /* ------------------------------------------------------------------ */

  /** Le premier fichier trop lourd de l'événement, ou null. */
  function tropLourd(ev) {
    var lots = [];
    try {
      var c = ev.target;
      if (c && c.files && c.files.length) lots.push(c.files);
      if (ev.dataTransfer && ev.dataTransfer.files && ev.dataTransfer.files.length) {
        lots.push(ev.dataTransfer.files);
      }
    } catch (e) { return null; }

    for (var i = 0; i < lots.length; i++) {
      var f = lots[i];
      for (var j = 0; j < f.length; j++) {
        if (f[j] && f[j].size > MAX) return f[j];
      }
    }
    return null;
  }

  function garder(ev) {
    var f;
    try { f = tropLourd(ev); } catch (e) { return; }
    if (!f) return;

    try {
      /* On coupe net : ni le champ, ni React, ni l'application ne verront
         passer ce fichier-là. */
      ev.preventDefault();
      ev.stopImmediatePropagation();
      if (ev.target && ev.target.tagName === "INPUT" && ev.target.type === "file") {
        ev.target.value = "";
      }
    } catch (e) { /* si on n'arrive pas à couper, on prévient quand même */ }

    dire(f.name, f.size);
  }

  try {
    document.addEventListener("change", garder, true);
    document.addEventListener("drop", garder, true);
    window.__VA_LOGO_MAX__ = MAX;
  } catch (e) { /* rien : le site fonctionne exactement comme avant */ }
})();
